const config = {
  apiUrl: 'https://problemsolver.lawnpride.com.au/backend/api',
  appUrl: '/',
};

export default config;